import {
  ControlOutlined,
  EnvironmentOutlined,
  GlobalOutlined,
  TabletOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons'
import FormCard from '@components/FormCard'
import { useHasAccess } from '@components/HasAccess'
import Page from '@components/Page/Page'
import { SBRMAction } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import Feature from '@components/Feature'
import { useFeature } from '@utils/featureFlags'
import { Permission } from '@utils/permissions'
import { Col } from 'antd'

const GeneralTab = () => {
  const { hasAccess } = useHasAccess()
  const { enabled: webBooking } = useFeature('webBooking')

  return (
    <Page rowGutter={[32, 32]} noWrapWithCol>
      <Col span={12}>
        <FormCard
          title="Main informations"
          icon={<ControlOutlined />}
          entity={Entity.venue}
          action={SBRMAction.Update}
          sections={['main']}
          disabled={!hasAccess(Permission.updateVenue)}
        />
      </Col>
      <Col span={12}>
        <FormCard
          title="Geographic informations"
          icon={<EnvironmentOutlined />}
          entity={Entity.venue}
          action={SBRMAction.Update}
          sections={['geographic']}
          disabled={!hasAccess(Permission.updateVenue)}
        />
      </Col>
      <Col span={12}>
        <FormCard
          title="Mobile application visibility"
          icon={<TabletOutlined />}
          entity={Entity.venue}
          action={SBRMAction.Update}
          sections={['app_visibility']}
          disabled={!hasAccess(Permission.updateVenue)}
        />
      </Col>
      <Col span={12}>
        <FormCard
          title="WhatsApp bot visibility"
          icon={<WhatsAppOutlined />}
          entity={Entity.venue}
          action={SBRMAction.Update}
          sections={['whatsapp_visibility']}
          disabled={!hasAccess(Permission.updateVenue)}
        />
      </Col>
      {webBooking && (
        <Col span={12}>
          {/* A card: a preview is framed (the Col only exists with the flag). */}
          <Feature flag="webBooking" preview="section">
            <FormCard
              title="Website visibility"
              icon={<GlobalOutlined />}
              entity={Entity.venue}
              action={SBRMAction.Update}
              sections={['web_visibility']}
              disabled={!hasAccess(Permission.updateVenue)}
            />
          </Feature>
        </Col>
      )}
    </Page>
  )
}

export default GeneralTab
